
import React from 'react';

import { connect } from 'react-redux';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';



import './terms2.scss';


// Hamburger
function loftyInitHam() {
  try {
    // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}





const Pterms2 = ({ match, loftytoken, loftyuser, addLoftyUserApp, deleteLoftytokenApp, addLoftyTokenApp }) => {



  setTimeout(() => { loftyInitHam(); }, 2000);





  return (
    <div id="id64d9fc4d92554645256473b1" >

      <div id="ivee" className="">

        <a
          target=""
          className=""
          id="ir745b"
          href="/"
        >

          <img
            className=""
            id="i1i8k"
            src="https://assetsprojects.s3.amazonaws.com/eewk3il9okodib.png"
            alt="undefined"
          />

        </a>

        <div id="" className="contentwrapperanimated ">

          <div id="" className="container_animated ">

            <label id="" className="menu__btn ">

              <span className="span_before " id="">

              </span>

              <span className="span_middle " id="">

              </span>

              <span className="span_after " id="">

              </span>

            </label>

            <label id="" className="menu__close__btn ">

              <span className="span__close__left " id="">

              </span>

              <span className="span__close__right " id="">

              </span>

            </label>

            <ul id="" className="menu__box ">

              <li className="linkshref " id="">

                <a
                  target=""
                  className="menu__item "
                  id=""
                  href="/"
                  type=""
                >
                  <span>Home</span>
                </a>

              </li>

              <li className="linkshref " id="">

                <a
                  target=""
                  className="menu__item "
                  id=""
                  href="/products"
                  type=""
                >
                  <span>Shop</span>
                </a>

              </li>

              <li className="linkshref " id="">

                <a
                  target=""
                  className="menu__item "
                  id=""
                  href="/aboutus"
                  type=""
                >
                  <span>About Us</span>
                </a>

              </li>

              <li className="linkshref " id="">

                <a
                  target=""
                  className="menu__item "
                  id=""
                  href="/cartpage"
                  type=""
                >
                  <span>Shopping Cart</span>
                </a>

              </li>

              <li className="linkshref " id="">

              </li>

            </ul>

          </div>

        </div>

        <div id="iq9l" className="">

          <a
            target=""
            className=""
            id="i5tql"
            href="/"
          >

            <div id="i1n85" className="">
              <span>Home</span>
            </div>

          </a>

          <a
            target=""
            className=""
            id="ifv1s"
            href="/products"
          >

            <div id="iqceg" className="">
              <span>Shop</span>
            </div>

          </a>

          <a
            target=""
            className=""
            id="ikkdy"
            href="/aboutus"
          >

            <div id="if57z" className="">
              <span>About Us</span>
            </div>

          </a>

          <a
            target=""
            className=""
            id="i3f72l"
            href="/blog"
          >

            <div id="ihp1gj" className="">
              <span>Blog</span>
            </div>

          </a>

          <form id="islmj" className="" onSubmit={(e) => {
            e.preventDefault();
            const doc = {
              q: e.target.search.value,
            }
            const query = new URLSearchParams(doc);
            window.location.href = `/products?${query.toString()}`
          }}>

            <div id="iwr3jd" className="">

              <input
                name=""
                type="text"
                placeholder="Search"
                className=""
                id="ib4ir6"
              />

            </div>

            <button
              type=""
              name=""
              id="iyknx"
              className=""

            >

              <div id="ivb27" className="">
                <span>Search</span>
              </div>

            </button>

          </form>

          <div id="inqxd" className="">

            <a
              target=""
              className=""
              id="i6hs3"
              href="/cartpage"
            >

              <img
                className=""
                id="ijy2n"
                src="https://assetsprojects.s3.amazonaws.com/404p7nilj3fs1w7.png"
                alt="undefined"
              />

            </a>

          </div>

        </div>

      </div>

      <div id="ipezzh" className="">

        <div id="ivp3c" className="">

          <p className="" id="i0pfy">
            <span>Terms and conditions</span>
          </p>

        </div>

      </div>

      <div id="ihis35" className="">

        <div id="ixobj" className="">

          <div id="iml6i" className="">

            <p className="" id="i6rsk">

              <p className="MsoNormal " id="ia7d7">

                <b className="" id="">
                  <span>1. Introduction</span>
                  <br className="" id="" />

                </b>
                <span>Through these terms and conditions of use (hereinafter the "Terms and Conditions"), the conditions of access and use of the virtual platform and mobile application "ID HUNTER" or "SPOTTY TAG" operated by the North American company are established. Fishermind Tech LLC., domiciled in the city of Mansfield, State of Massachusetts, USA. and who for the purposes of these terms and conditions will be known as the "Operator".</span>
                <br className="" id="" />

                <br className="" id="" />
                <span>For the company Fishermind Tech LLC. It is extremely important to keep our users informed about the use and operation of our virtual platform and our mobile application. For this reason and through this document we will allow US to inform about the terms and Conditions by which the use and navigation of the Virtual Platform and mobile application "ID HUNTER" or "SPOTTY TAG" will be governed for linking Users who in turn are operated by FISHER MIND TECH LLLC.</span>
                <br className="" id="" />

                <br className="" id="" />
                <span>The purpose of this document is to publicize in a clear and precise manner how the access and use of our Virtual ID Hunter Platform is regulated for the linking of Users. In this way, it is necessary to remember that the access and use of this tool will be conditioned to the acceptance and compliance with each of these Terms and conditions. The terms and conditions regulate the Virtual Platform and mobile App, and in general, regulate the conditions of use, use and execution of any form of the "ID HUNTER" or "SPOTTY TAG" platform, and the Services offered by it.</span>
                <br className="" id="" />

                <br className="" id="" />
                <span>It is worth mentioning that by accepting these terms and conditions, you are subject to these obligations when accessing or using the Virtual Platform and mobile App, or through any unequivocal conduct that allows you to conclude that you have accepted our terms and conditions of use. If the user does not agree with any part of the Terms, they will not be able to access the service of our Platform and mobile App. We remind you that the only person responsible for the information and content published on the Platform, including its readability, veracity, reliability, adequacy IS THE USER and that said information does not violate privacy rights, publicity rights, copyright, contractual rights or any other right of any person. In this way, the user expressly grants us the right and license to use, modify, publicly perform, publicly display, reproduce and distribute said information and content in accordance with our data privacy policy that you can consult on our website.</span>
                <br className="" id="" />

              </p>

            </p>

            <p className="" id="icqc6a">

              <p className="MsoNormal " id="ic7y04">
                <span>That is why we invite you to carefully read these Terms and Conditions of use before using our Platform and Mobile App ID HUNTER!</span>
                <br className="" id="" />

              </p>

            </p>

            <p className="" id="izboml">

              <p className="MsoNormal " id="ihus3">

                <b className="" id="">
                  <span>2. GENERAL</span>
                  <br className="" id="" />

                </b>
                <span>a. These terms and conditions include the relationship between the user and the Platform and Mobile App "ID HUNTER" or "SPOTTY TAG".</span>
                <br className="" id="" />
                <span>b. With the acceptance of our terms and conditions, the use of the Platform and Mobile App "ID HUNTER" or "SPOTTY TAG" is enabled according to the object contained in this document, in the same way you can use the different functionalities that have been developed through the same.</span>
                <br className="" id="" />
                <span>c. You declare and guarantee that the content and information provided is yours or you have the right to use it and grant us the rights and license as stipulated in this document, as well as the publication of this.</span>
                <br className="" id="" />

              </p>

            </p>

            <p className="" id="i8k63o">

              <p className="MsoNormal " id="il1smf">

                <b className="" id="">
                  <span>3. FUNCTIONALITIES</span>
                  <br className="" id="" />

                </b>
                <span>a. Users must create an account in the Mobile App with their email (directly or by entering one of the linkable social networks, (Facebook, twitter, Instagram, etc.)) and a respective password. If you forget your password, you will have an option to recover it by following the steps indicated in the App.</span>
                <br className="" id="" />
                <span>b. The User must create a new profile for each pet for which they have made the respective purchase of the "ID HUNTER" or "SPOTTY TAG" pet identity tag. Once created, you must wait for validation by the technical and administrative team in a virtual and automated way.</span>
                <br className="" id="" />
                <span>c. Once the pet's profile has been created and validated, the certificate with the name and number data of the system will be automatically sent in PDF format directly to the User's email.</span>
                <br className="" id="" />

              </p>

            </p>

            <p className="" id="i34eng">

              <p className="MsoNormal " id="iiuqvh">

                <b className="" id="">
                  <span>4. ACCESS AND REGISTRATION</span>
                  <br className="" id="" />

                </b>
                <span>Each person who enters the Website and/or Mobile Applications will be responsible for carrying out all the necessary procedures to have access to it. The mere fact of visiting the Website and/or Mobile Applications will not give rise to any obligation for the User or for third parties, unless it is expressed unequivocally and by externalized positive acts, their willingness to operate and make use of the Services. It is for the foregoing that the Terms and Conditions will be understood to be accepted once the user is registered on the Website and/or Mobile Applications operated by FISHERMIND TECH LLC., a fact that translates into the express acceptance of the Terms and Conditions Any User who wishes to use the Service must register on the Website and/or Mobile Applications as detailed below, which implies express acceptance of these Terms and Conditions. The account of each User is personal, unique and non-transferable, it is prohibited for the same user to register or have more than one account, as well as the type of assignment or transfer of accounts to third parties. To carry out the enrollment and registration on the Website and/or Mobile Applications, it will be mandatory to complete the registration form in all its fields with valid data and exact, complete and true personal information (hereinafter, the "User Data") . This information will correspond to the minimum information that FISHERMIND TECH LLC. requests Users to carry out the quotation of a product and/or service. The User undertakes to update the User Data as soon as it is modified when using the Website and/or Mobile Applications. Users guarantee the veracity of the User Data provided in the registration form, and will be responsible for any lack of veracity, inaccuracy, or authenticity thereof. All information and User Data entered by the User have the character of a declaration sworn. Once registered, the User will be able to access the Website and/or Mobile applications and the services associated with them, by linking with their email. Fishermind Tech LLC reserves the right to request proof and/or additional information in order to corroborate the information provided by a User regarding Personal Data, as well as to temporarily or permanently suspend those Users whose data could not be confirmed, likewise reserves the right to reject a registration request or to cancel or suspend, temporarily or permanently, an account, in case of detecting inconsistencies or inconsistencies in the information provided by a User or in case of detecting suspicious activities, without such decision generating for the User rights of compensation or compensation of any kind.</span>
                <br className="" id="" />

              </p>

            </p>

            <p className="" id="i3qnux">

              <p className="MsoNormal " id="i250tu">

                <b className="" id="">
                  <span>5. PERSONAL DATA AND NOTIFICATIONS</span>
                  <br className="" id="" />

                </b>
                <span>All the contents included in the Website and/or Mobile Applications, such as texts, graphic material, logos, button icons, source codes, images, audio clips, digital downloads and data compilations, are the property of FISHERMIND TECH LCC. or its content providers, and are protected by United States and international copyright laws. The graphic materials, logos, page headers, advertising phrases, button icons, written texts and names of services included in the Website and/or Mobile Applications are trademarks, creations or commercial images owned by FISHERMIND TECH LLC. Said trademarks, creations and commercial images may not be used in relation to any product or service that may cause confusion to third parties and in any way that discredits or discredits the company in question. Other trademarks not owned by FISHERMIND TECH LCC that appear on this site belong to their respective owners. All rights not expressly granted in these Terms and Conditions are reserved by FISHERMIND TECH LLC or its assignees, Suppliers, publishers, rights holders or other content providers. No product, image or sound may be reproduced, duplicated, copied, sold, resold, visited or otherwise exploited for any purpose, in whole or in part, without the prior written consent of the company. You may not frame or utilize framing techniques to enclose any trademark, logo, or other proprietary or proprietary information (including images, text, page layout, or form) of ID HUNTER without ID HUNTER's written consent. You may also not use meta tags or any other “hidden text” using ID HUNTER's name or trademarks without prior written permission from ID HUNTER. Improper use of the Website and/or Mobile Applications or these trademarks, licenses or patents is prohibited. The foregoing, without prejudice to the exceptions expressly indicated in the law.</span>
                <br className="" id="" />

              </p>

            </p>

            <p className="" id="ifml7j">

              <p className="MsoNormal " id="ilwj6i">

                <b className="" id="">
                  <span>6. ANNEXES AND APPLICABLE LEGISLATION</span>
                  <br className="" id="" />

                </b>
                <span>In the event that any of the provisions of these Terms and Conditions is judicially declared as not mandatory, such failure will not affect compliance with the rest of the provisions. If any provision of these Terms and Conditions is held invalid, unenforceable, null and void by any competent administrative body or court, or if, by law, any provision becomes invalid, unenforceable, null and void, the remaining provisions will remain valid, in full force and effect and the parties will replace the invalid, null or unenforceable provision with another valid and applicable one that comes as close as possible to the spirit and purpose of the replaced standard. If for any reason a court or tribunal of competent jurisdiction or an arbitrator determines that any provision of these Terms and Conditions is not applicable, or is null or for any reason, ineffective, said provision will apply to the extent permitted and the other Terms of Service will continue to apply. The delay or non-exercise of a right or remedy will not be considered as a waiver. It is worth mentioning that FISHERMIND TECH LLC is an American company and will be governed particularly by the applicable regulations.</span>
                <br className="" id="" />

              </p>

            </p>

            <p className="" id="ix0jgr">

              <p className="MsoNormal " id="iqo9gn">

                <b className="" id="">
                  <span>7. MODIFICATIONS, UPDATES AND/OR CHANGES</span>
                  <br className="" id="" />

                </b>
                <span>The Operator reserves the right to make any respective, corresponding and necessary modification or update at any time in order to comply with the corresponding regulations, legislation and/or requirements to comply with our purpose. These modifications will be published and communicated through our website or through institutional emails.</span>
                <br className="" id="" />
                <span>It is also reported that by continuing to access or use our mobile or web applications after those revisions become effective, the User expressly agrees to be bound by the new revised terms and conditions.</span>
                <br className="" id="" />

                <br className="" id="" />
                <span>FISHERMIND TECH LLC is allowed to inform that the terms and conditions of use of the mobile and web application, its modifications and / or updates are valid from the date of its publication.</span>
                <br className="" id="" />

              </p>

            </p>

            <p className="" id="i6cudw">

              <p className="MsoNormal " id="ijwyhx">

                <b className="" id="">
                  <span>8. CONTACT</span>
                  <br className="" id="" />

                </b>
                <span>To address any questions or concerns, the user can contact through the website http://www.Idhuntersystems.com/ and or email ceofishermind@gmail.com</span>
                <br className="" id="" />

              </p>

            </p>

          </div>

        </div>

      </div>

      <div id="ie6sa" className="">

        <div id="iqobg" className="">

          <p className="" id="ibllc">
            <span>Contact us for more information!</span>
            <br className="" id="" />

          </p>

          <div id="ihuk4" className="">

            <div id="iu87j" className="">

              <img
                className=""
                id="i67f"
                src="https://assetsprojects.s3.amazonaws.com/eewk3il9okodib.png"
                alt="undefined"
              />

            </div>

            <div id="iwg4f" className="">

              <a
                target="_blank"
                className=""
                id="irgjju"
                href="https://www.instagram.com/spottytaghn/"
              >

                <img
                  className=""
                  id="iqcul1"
                  src="https://assetsprojects.s3.amazonaws.com/404p7nilj3hafi3.png"
                  alt="undefined"
                />

                <p className="" id="iqq4mu">
                  <span>@spottytaghn</span>
                </p>

              </a>

              <a
                target="_blank"
                className=""
                id="i5vgyt"
                href="https://www.facebook.com/spottytaghn"
              >

                <img
                  className=""
                  id="iae27s"
                  src="https://assetsprojects.s3.amazonaws.com/404p7nilj3he6f6.png"
                  alt="undefined"
                />

                <p className="" id="ikdl4l">
                  <span>spottytaghn</span>
                </p>

              </a>

              <a
                target=""
                className=""
                id="ii2lsw"
                href="https://api.whatsapp.com/send?phone=50433027674"
              >

                <img
                  className=""
                  id="iu0rp5"
                  src="https://assetsprojects.s3.amazonaws.com/404p7nilj3hfpjb.png"
                  alt="undefined"
                />

                <p className="" id="iqzql2">
                  <span>+504 3302-7674</span>
                </p>

              </a>

              <a
                target=""
                className=""
                id="i0mmmx"
                href="mailto:customerservice@spottytag.com"
              >

                <img
                  className=""
                  id="ih8ro2"
                  src="https://assetsprojects.s3.amazonaws.com/404p7nilj3hg2uk.png"
                  alt="undefined"
                />

                <p className="" id="ivdrgi">
                  <span>customerservice@spottytag.com</span>
                </p>

              </a>

            </div>

          </div>

        </div>

      </div>

      <div id="ig891" className="">

        <p className="" id="i7l1k">
          <span>©2023 | spotty tag hn | privacy policies | terms of use</span>
          <br className="" id="" />

        </p>

      </div>

    </div>
  );
}

const mapStateToProps = (state) => state.auth;



export default connect(mapStateToProps)(Pterms2);
